import { AnalyticsAction, AnalyticsResetEcomAction, WindowWithDataLayer } from '@analytics/const';
import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CookieKeys, environment } from '@core/const';
import { CookieService, EnvironmentService } from '@core/feature';
import { DebugAnalyticsService } from './debug-analytics.service';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  constructor(
    private environmentService: EnvironmentService,
    @Inject(PLATFORM_ID) private platformId: string,
    private debugAnalytics: DebugAnalyticsService,
    private cookieService: CookieService,
  ) {}

  init(): void {
    if (!this.isEnabled) {
      return;
    }

    (function (w: any, d: any, s: string, l: string, i: string): void {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      const f = d.getElementsByTagName(s)[0],
        j = <HTMLScriptElement>d.createElement(s),
        dl = l !== 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-KQWDPB8');
  }

  sendEvent(action: AnalyticsAction | AnalyticsResetEcomAction): void {
    if (!this.isEnabled) {
      this.debug('analytics action:', action);

      return;
    }

    const w = <WindowWithDataLayer>window;

    if (w.dataLayer === undefined) {
      w.dataLayer = [];
    }
    w.dataLayer.push(action);
  }

  sendEcommerceEvent(action: AnalyticsAction | AnalyticsResetEcomAction): void {
    if (action.ecommerce !== null) {
      this.sendEvent({ ecommerce: null });
    }
    this.sendEvent(action);
  }

  private debug(name: string, data: any): void {
    if (this.environmentService.isPlatformBrowser && this.debugAnalytics.debug) {
      // eslint-disable-next-line no-console
      console.log(name, data);
    }
  }

  private get isEnabled(): boolean {
    if (this.cookieService.isAutomationTest() || this.cookieService.get(CookieKeys.ATTDisableAnalytics) === '1') {
      return false;
    }

    return isPlatformBrowser(this.platformId) && environment.production;
  }
}
